var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-audio", attrs: { "data-grm-comp": "RoomCallAudio" } },
    _vm._l(_vm.audioStreams, function (audioData) {
      return _c("audio", {
        key: audioData.track.id,
        ref: "audios",
        refInFor: true,
        attrs: {
          autoplay: "",
          "data-user-id": audioData.userId,
          "data-track-id": audioData.stream.getAudioTracks()[0]?.id,
        },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }